import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import FlatPiercingImage from '../../Assets/Piercing Services/flat piercing (3).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function FlatPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Flat Piercing UAE | 150-175 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Flat Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Flat Piercing 150-175 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={FlatPiercingImage} alt="Flat Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Flat Piercing</h3>

          <p>
            Enhance your ear styling with our professional flat piercing services in the UAE, available at an affordable price range of 150–175 AED. Flat piercing is a trendy and elegant cartilage piercing placed on the flat area of the upper ear, offering a clean and modern look that is perfect for showcasing studs and small hoops. This versatile piercing style is ideal for individuals who want to create a curated ear design with a smooth and balanced aesthetic. Whether you prefer a minimal stud for a subtle touch or multiple pieces for a bold statement, our expert specialists ensure precise placement to achieve a flawless and visually appealing result.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each flat piercing with accuracy and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Our goal is to provide a quick, efficient, and pain-minimized procedure, making flat piercing suitable for both first-time clients and those looking to expand their ear piercing collection.
          </p>

          <p>
            Flat piercing is perfect for those who want a modern and stylish ear look with plenty of room for creativity. Its placement on the flat surface of the ear allows for unique jewelry arrangements, making it a popular choice for stacking multiple studs or combining it with other piercings such as helix, conch, or lobe. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry options to suit your ear structure and personal style. This personalized approach ensures that your piercing complements your overall appearance beautifully.
          </p>

          <p>
            The procedure is typically completed within minutes, ensuring minimal discomfort and maximum convenience. Our team uses advanced techniques designed to reduce pain and promote faster healing, allowing you to enjoy your new piercing without unnecessary stress. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a comfortable healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that cartilage piercings can sometimes feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your flat piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your flat piercing will heal effectively and remain a stylish and long-lasting addition to your look.
          </p>

          <p>
            Our flat piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden charges. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted flat piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a modern and elegant ear look effortlessly. Book your flat piercing appointment today and elevate your style with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Flat Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default FlatPiercing;